import * as Monitaro from '@/infrastructure/network/Monitaro/schema/models'
import { APIRequest } from '@/infrastructure/network/APIRequest'
import { HTTPMethod } from '@/infrastructure/network/types'

/**
 * チャットルームのトーク一覧
 *
 * 指定されたチャットルームのトークデータの一覧を返す
 */
export class FetchTalk implements APIRequest<Monitaro.FetchTalkResponse> {
  response: Monitaro.FetchTalkResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.GET
  params?: Monitaro.Query
  constructor(room: string, query?: Monitaro.Query) {
    this.params = query
    this.path = `/rooms/${room}/talks`
  }
}

/**
 * チャットルームへ発言
 *
 * 指定されたチャットルームにトークを発言する。
 */
export class PostTalk implements APIRequest<Monitaro.PostTalkResponse> {
  response: Monitaro.PostTalkResponse
  path: string
  contentType = 'multipart/form-data'
  method = HTTPMethod.POST
  params: Monitaro.TalkRequest
  constructor(room: string, params: Monitaro.TalkRequest) {
    this.params = params
    this.path = `/rooms/${room}/talks`
  }
}

/**
 * トークデータの取得
 *
 * 指定されたIDのトークデータを取得する
 */
export class GetTalk implements APIRequest<Monitaro.GetTalkResponse> {
  response: Monitaro.GetTalkResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.GET
  constructor(room: string, talk: string) {
    this.path = `/rooms/${room}/talks/${talk}`
  }
}

/**
 * 発言したトークデータの編集
 *
 * 発言したトークデータを編集する
 * 不要な可能性もあるので一旦実装は無視してください
 */
export class PutTalk implements APIRequest<Monitaro.PutTalkResponse> {
  response: Monitaro.PutTalkResponse
  path: string
  contentType = 'multipart/form-data'
  method = HTTPMethod.PUT
  params: Monitaro.TalkRequest
  constructor(room: string, talk: string, params: Monitaro.TalkRequest) {
    this.params = params
    this.path = `/rooms/${room}/talks/${talk}`
  }
}

/**
 * 発言したトークデータの削除
 *
 * 自分が発言したトークデータを削除する
 */
export class DeleteTalk implements APIRequest<Monitaro.DeleteTalkResponse> {
  response: Monitaro.DeleteTalkResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.DELETE
  params: Monitaro.TalkRequest
  constructor(room: string, talk: string) {
    this.path = `/rooms/${room}/talks/${talk}`
  }
}
